import { pagesSchema } from '@messenger/types'
import type {
  GetGlobalPagesNormalized,
  GetFuneralHomePagesNormalized,
} from '@messenger/types'
import axios from '@/api/axios.config'
import { z } from 'zod'

export const getPages = async (
  pageSetId: z.infer<typeof pagesSchema>['pageSetId'],
) => {
  return await axios.get<
    (GetGlobalPagesNormalized | GetFuneralHomePagesNormalized)[]
  >(`pages?page_set_id=${pageSetId}`)
}
